<template>
  <canvas ref="host"></canvas>
</template>

<script>
import { WMSModel, windowBoundsModel, defaultFocusModel } from "vue-niney";

export default {
  name: "NWMSLayer",
  props: {
    srs: { type: Object },
    layer: { type: Object },
    loader: { type: Object },
    info: { type: Object }
  },
  data: function() {
    return {
      boundsModel: null,
      focusModel: null
    }
  },
  mounted: function() {
    this.boundsModel = this.$parent.boundsModel;
    this.focusModel = this.$parent.focusModel;
    
    this.$refs.host.width = this.boundsModel.bounds.width;
    this.$refs.host.height = this.boundsModel.bounds.height;
    
    this.wmsModel = new WMSModel();
    this.wmsModel.ctx = this.$refs.host.getContext("2d");
    this.wmsModel.srs = this.srs || this.focusModel.srs;
    this.wmsModel.loader = this.loader;
    this.wmsModel.setBounds(this.boundsModel.bounds);
    this.wmsModel.setIncubationBounds(this.boundsModel.incubationBounds);
    this.wmsModel.setAnimationCenterScale(this.focusModel.animationCenterScale);
    this.wmsModel.setCenterScale(this.focusModel.incubationCenterScale);
    this.wmsModel.setLayer(this.layer);
  },
  watch: {
    "$parent.boundsModel": function (val) {
      this.boundsModel = val;
    },
    "$parent.focusModel": function (val) {
      this.focusModel = val;
      this.wmsModel.srs = this.srs || val.srs;
    },
    "boundsModel.bounds": function(val) {
      this.$refs.host.width = val.width;
      this.$refs.host.height = val.height;
      
      this.wmsModel.setBounds(val);
    },
    "boundsModel.incubationBounds": function(val) {
      this.wmsModel.setIncubationBounds(val);
    },
    "focusModel.animationCenterScale": function(val) {
      this.wmsModel.setAnimationCenterScale(val);
    },
    "focusModel.incubationCenterScale": function(val) {
      this.wmsModel.setCenterScale(val);
    },
    srs: function(val) {
      this.wmsModel.srs = val || this.focusModel.srs;
    },
    layer: function(val) {
      this.wmsModel.setLayer(val);
    },
    "layer.visible": function(val) {
      this.wmsModel.load();
    },
    loader: function(val) {
      this.wmsModel.loader = val;
    },
    info: function(val) {
      this.wmsModel.info = val;
      this.wmsModel.load(true);
    }
  }
}
</script>

<style scoped>
canvas {
  display: block;
  position: absolute;
  height: 100%;
}
</style>

